export default "__VITE_ASSET__c6160075__"